import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var FailedDeliveryAttempt = function FailedDeliveryAttempt() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ObOGqM",
    defaultMessage: [{
      "type": 0,
      "value": "Quando uma tentativa de entrega falha, é essencial agir rapidamente para resolver a situação e garantir que o envio chega ao revendedor de forma bem sucedida. Pode optar pelo seguinte:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Dk6+pO",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Contacte a transportadora:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " entre de imediato em contacto com a transportadora para perceber o motivo da tentativa de entrega ter falhado e discutir a possibilidade de tentar efetuar novamente a entrega."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fHRo9Q",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Envie uma mensagem ao revendedor:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " informe o revendedor sobre a tentativa de entrega falhada e sobre quaisquer atualizações ou alterações que possam afetar o prazo de entrega."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "v4mWlX",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verifique o endereço de envio:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " verifique novamente o endereço de envio fornecido pelo revendedor. Se existirem discrepâncias, confirme o endereço correto com o revendedor."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "/2TRVS",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Organize o reenvio:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " assim que o endereço for confirmado e quaisquer problemas forem resolvidos, coordene com a transportadora para agendar o reenvio o mais rapidamente possível."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};